module.exports = __webpack_public_path__ + "img/121marketing-logo.4a39f6c3.png";